'use client';

import { createContext, useContext, useState } from 'react';
import { TrailSearchResult } from '@alltrails/search/types/algoliaResultTypes';
import { AllTrailsResult } from '../..';

const TrailListMapContext = createContext({
  cardHoveredResult: undefined as AllTrailsResult | undefined,
  setCardHoveredResult: (_?: AllTrailsResult) => {}
});

type Props = {
  trails?: TrailSearchResult[];
  children: React.ReactNode;
};

export const TrailListMapProvider = ({ children }: Props) => {
  const [cardHoveredResult, setCardHoveredResult] = useState<AllTrailsResult | undefined>();

  return (
    <TrailListMapContext.Provider
      value={{
        cardHoveredResult,
        setCardHoveredResult
      }}
    >
      {children}
    </TrailListMapContext.Provider>
  );
};

export const useLocationMap = () => useContext(TrailListMapContext);
